var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c(
        "div",
        [
          _c("preloader", {
            staticClass: "loader loader-big",
            attrs: { display: _vm.display }
          }),
          _vm._v(" "),
          _vm.showMessage
            ? _c("div", { staticClass: "fallback-message" }, [
                _c("p", [_vm._v(_vm._s(_vm.errorMessage))]),
                _vm._v(" "),
                _c("a", { attrs: { href: _vm.fallbackLink } }, [
                  _vm._v(_vm._s(_vm.fallbackText))
                ])
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }